import { useEffect, useState } from 'react'
import { IdleTimerProvider } from 'react-idle-timer';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import AddBendahara from '../pages/auth/admin/Bendahara/Add';
import DataBendahara from '../pages/auth/admin/Bendahara/Data';
import Bendahara from '../pages/auth/admin/Bendahara/Index';
import Bud from '../pages/auth/admin/Bud';
import AddBud from '../pages/auth/admin/Bud/Add';
import DataBud from '../pages/auth/admin/Bud/Data';
import Home from '../pages/auth/admin/Home';
import DetailAdendum from '../pages/auth/admin/kontrak/adendum/Detail';
import DetailKontrak from '../pages/auth/admin/kontrak/Detail';
import Kontrak, { DataKontrak } from '../pages/auth/admin/kontrak/Index';
import NavAdmin from '../pages/auth/admin/Nav';
import Opd from '../pages/auth/admin/Opd/Index';
import Spm, { DataSpm } from '../pages/auth/admin/Permintaan/Index';
import ProsesSp2d, { DataProsesSp2d } from '../pages/auth/admin/ProsesSp2d/Index';
import Selesai from '../pages/auth/admin/Selesai';
import AddVerifikator from '../pages/auth/admin/Verifikator/Add';
import Verifikator, { DataVerifikator } from '../pages/auth/admin/Verifikator/Index';
import Kelengkapan from '../pages/auth/verif/Kelengkapan';
import { AuthStore } from '../store/UserStore';
import { CustomDescrypt } from '../utils/MyEncryption';

const Admin = props => {
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);
    const logOut = AuthStore((state) => state.logOut);

    useEffect(() => {
        if (encryptUser === null || encryptUser === undefined) {
            navigate("/login", { replace: true });
        }
        else {
            if (decryptedUser.user === null) {
                navigate("/login", { replace: true });
            }
            else {
                if (decryptedUser.role !== 'Admin') {
                    setIsAdmin(false)
                    navigate("/login", { replace: true });
                }
                else {
                    setIsAdmin(true)
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [encryptUser, location, decryptedUser]);

    const onIdle = () => {
        // Close Modal Prompt
        // Do some idle action like log out your user
        console.log('on idle');
        logOut();
    }

    const handleLogOut = () => {
        logOut();
        navigate("/", { replace: true });
    }

    if (isAdmin) {
        console.log("Admin true");
        return (
            <IdleTimerProvider
                timeout={1000 * 60 * 60}
                // onPrompt={onPrompt}
                onIdle={onIdle}
            // onActive={onActive}
            // onAction={onAction}
            >
                {/* {props.component} */}
                <NavAdmin child={
                    <Routes>
                        <Route exact path='' element={<Home />} />
                        <Route exact path='spm' element={<Spm />}>
                            <Route exact path='' element={<DataSpm />} />
                        </Route>

                        <Route exact path='proses_sp2d' element={<ProsesSp2d />} >
                            <Route exact path='' element={<DataProsesSp2d />} />
                        </Route>

                        <Route exact path='selesai' element={<Selesai />} />

                        <Route exact path='kontrak' element={<Kontrak />}>
                            <Route exact path='' element={<DataKontrak />} />
                            <Route exact path='detail' element={<DetailKontrak />} />
                            <Route exact path='adendum-detail' element={<DetailAdendum />} />
                        </Route>

                        <Route exact path='bendahara' element={<Bendahara />} >
                            <Route exact path='' element={<DataBendahara />} />
                            <Route exact path='add' element={<AddBendahara />} />
                        </Route>
                        <Route exact path='verifikator' element={<Verifikator />} >
                            <Route exact path='' element={<DataVerifikator />} />
                            <Route exact path='add' element={<AddVerifikator />} />
                        </Route>
                        <Route exact path='opd' element={<Opd />} />
                        <Route exact path='bud' element={<Bud />} >
                            <Route exact path='' element={<DataBud />} />
                            <Route exact path='add' element={<AddBud />} />
                        </Route>
                        <Route exact path='kelengkapan' element={<Kelengkapan />} />
                    </Routes>
                } onLogOut={handleLogOut} setMode={props.setMode} mode={props.mode} />
            </IdleTimerProvider>
        )
    }
}

export default Admin